import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {StyleService, StyleType} from '../../services/style.service';

@Component({
    selector: 'app-loyalty-payment-complete',
    templateUrl: './loyalty-payment-complete.component.html',
    styleUrls: ['./loyalty-payment-complete.component.scss'],
})
export class LoyaltyPaymentCompleteComponent implements OnInit, OnDestroy {
    public readonly StyleType = StyleType;

    @Input()
    queueNumber: Number = 0;

    queueText: String;

    timer = 10;
    interval;

    constructor(
        private modalCtrl: ModalController,
        public styleService: StyleService) { }

    ngOnInit() {
        if(this.queueNumber > 0) {
            this.queueText = "Kø nummer: #" + String(this.queueNumber).slice(-2);
        }
        this.interval = setInterval(() => {
            this.timer--;
            if (this.timer <= 0) {
                this.dismiss('timer')
            }
        }, 1000)
    }

    ngOnDestroy() {
        clearInterval(this.interval)
    }

    dismiss(status) {
        clearInterval(this.interval)
        this.modalCtrl.dismiss({
            'status': status
        })
    }
}
